const clientsSx = (theme) => ({
    searchContainer: {
        marginBottom: '64px',
    },
    searchButtons: {
        margin: '8px',
    },
});

export default clientsSx;
